import { appSettings } from "@cayo/shared/settings/appSettings";

export const clearAuthData = () => {
  localStorage.removeItem("token");
  sessionStorage.clear();
  appSettings.userSetting.update({ loginHint: undefined, authMode: undefined });
};
